function o(n) {
  return n && n.ownerDocument || document;
}
export {
  o
};
//# sourceMappingURL=ownerDocument-CUrv0DIK.mjs.map
